<template>
   <div class="gens-universes">
       <div class="gens-detail">
           <div class="detail-content">
               <div class="post_image">
                    <img class="post_image_img" src="../../assets/images/gensunicerse/190927-feature-measles.jpg"/>
               </div>
               <div class="post_text">
                   <div class="post_tip">無免疫力孕婦的患麻疹 最嚴重可流產</div>
                   <div class="post_info">Posted at 09:00h in 傳染病</div>
                   <p class="post_wrapper">本港今年年初發生的麻疹疫情非常嚴重，雖然現在情況可說是受到控制，但各界也不能掉以輕心。
                       發生麻疹疫情當時其中涉及一名患者為28歲孕婦，該婦女報稱曾接種過麻疹疫苗，而她懷疑在傳染期內到母嬰健康院做產檢時感染的。</p>
                    <div class="post_tip_1">
                        香港大學感染及傳染病中心醫生表示，若孕婦對麻疹無免疫力，可能引發肺炎、腦炎等併發症，外國亦曾有早產、流產案例。
                    </div>
                    <div class="post_wrapper_1">大部份人都曾接種麻疹疫苗，故即使抗體水平下降亦能提供多一層保護，減低出現嚴重併發症風險。專家認為疫苗保護力因人而異，免疫力也可能會隨著年紀增長而下降。所以為了確保自己免疫力能發揮有效的保護力，
                        最好的方法就是進行抗體檢測
                        （
                        <a href="#">血清抗體檢測</a>
                        ）
                        來確保體內有足夠抗體的水平。孕婦亦避免在人多密集的地方，以及前往產檢時都應當佩戴口罩，減低中招機率。
                    </div>
                    <div class="post_wrapper_tip">外國曾有過流產案例</div>
                    <div class="post_wrapper_1">
                        醫生表示，對於沒有麻疹免疫力的孕婦來說，一旦感染有機會引致並發症，包括肺炎和腦炎。外國亦曾有孕婦感染後早產及流產的案例；若孕婦並發症嚴重，甚至會胎死腹中。
                    </div>
                    <div class="post_wrapper_tip">麻疹的抗體水平</div>
                    <div class="post_wrapper_1">若孕婦接種時間太早，如已經過去20年，體內的抗體水平有可能下降到較低水平，都擔心難以抵抗麻疹病毒。孕婦注射疫苗有機會造成流產，應先檢查體內有沒有麻疹的抗體，沒有的話就只能多做預防和加強衛生。</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190927-pregnant-vaccine.jpg"/>
                    </div>
                    <div class="post_wrapper_tip">進行抗體檢測</div>
                    <div class="post_wrapper_1">
                        所以孕婦如對自己的免疫力有懷疑，應該進行抗體檢測（血清抗體檢測）來確保體內有足夠抗體的水平，孕婦就算只有少量的抗體數量都能提供多一層保護，出現嚴重並發症的可能性則較低。
                    </div>
                    <div class="post_wrapper_tip">人口密集地、產檢時孕婦應佩戴口罩</div>
                    <div class="post_wrapper_1">醫生提醒孕婦，在人口密集的地方，如巴士、地鐵、密閉空間等，孕婦應佩戴口罩；如有產檢的必要，在醫院、診所等地方，亦應當佩戴口罩後再進入，以防病毒透過飛沫接觸傳播，保障自己。</div>
                    <div class="post_wrapper_img">
                        <img  src="../../assets/images/gensunicerse/190927-wearing-mask.jpg"/>
                    </div>
                    <div class="post_wrapper_1">
                        資料來源：<a href="#">香港01</a>
                    </div>
               </div>
           </div>
           <div class="detail-list-menu">
               <div class="list-menu-item">
                   	<h5>最新資訊</h5>		
                       <ul>
							<li>
					            <a href="#/gensone">無免疫力孕婦的患麻疹 最嚴重可流產</a>
							</li>
							<li>
					            <a href="#/genstwo">無入侵性抽血驗癌症 適宜年老病人</a>
							</li>
							<li>
					            <a href="#/gensthree">最易被忽略的一種過敏食物</a>
							</li>
							<li>
					            <a href="#/gensfour">樂觀女性生仔機會較大</a>
						    </li>
							<li>
					            <a href="#/gensfive">雙胞胎兒竟然是同母異父</a>
							</li>
					</ul>
               </div>
               <div class="list-menu-item">
                   <h5>分類</h5>		
                   <ul>
				       <li>
                           <a href="#/gensuniversecate?categoryName=传染病&isCategory=1">傳染病</a> (2)
                       </li>
                       <li >
                           <a href="#/gensuniversecate?categoryName=天赋基因&isCategory=1">天賦基因</a> (1)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=无创产前检测&isCategory=1">無創產前檢測</a> (2)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=生育健康&isCategory=1">生育健康</a> (4)
                        </li>
                        <li >
                            <a href="#/gensuniversecate?categoryName=癌症&isCategory=1">癌症</a> (4)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=致敏原&isCategory=1">致敏原</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=亲子鉴定&isCategory=1">親子鑑定</a> (1)
                        </li>
                        <li>
                            <a href="#/gensuniversecate?categoryName=遗传病&isCategory=1">遺傳病</a> (1)
                        </li>
                    </ul>
               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default {
    data(){
        return{
          
        }
    },
    mounted(){

    },
    methods:{

    }
}
</script>


<style lang="scss" scoped>
.gens-universes{
    width: 100%;
    position: relative;
    margin-top:1rem;
    text-align: center;
    font-family: 'Microsoft JhengHei',sans-serif !important;
    margin-bottom:25px;
    margin-top:25px;
    .gens-detail{
        text-align: left;
        margin-top:10px;
        width:57.5%;
        margin:auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .detail-content{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width:66.66%;
            .post_image{
                position: relative;
                width: 100%;
                display: block;
                .post_image_img{
                   max-width: 100%;
                   height: auto; 
                }
            }
            .post_text{
                .post_tip{
                    margin-top:35px;
                    color: #368da7;
                    font-size: 28px;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: 0;
                    text-transform: none;
                }
                .post_info{
                    display: inline-block;
                    width: 100%;
                    margin: 0 0 18px;
                    color: #bebebe;
                    font-weight: 500;
                    line-height: 27px;
                    font-size: 16px;
    
                }
                .post_wrapper{
                    
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                    display: block;
                }
                .post_tip_1{
                    margin-top:35px;
                    border-color: #368da7;
                    background-color: #e9faff;
                    padding: 14px 14px 14px 10px;
                    border-left: 4px solid #368da7;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;

                }
                .post_wrapper_1{
                    margin-top:10px;
                    color: #3a3a3a;
                    font-size: 16px;
                    line-height: 24px;
                    font-style: normal;
                    font-weight: 400;
                }
                .post_wrapper_1 a{
                    color:#368da7;
                    text-decoration: none;
                }
                .post_wrapper_1 a:hover{
                    color:#9bd9dd;;
                    text-decoration: none;
                }
                .post_wrapper_tip{
                    margin-top:35px;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 600;
                    text-transform: none;
                    color: #368da7;
                }
                .post_wrapper_img{
                    margin-top:35px;
                    text-align: center;
                    img{
                        vertical-align: middle;
                        height: auto;
                        max-width: 100%;
                    }
                    .bottom_tip{
                        margin-top: .2em;
                       font-size: .8em;
                    }
                }
            }
            
        }
        .detail-list-menu{
            width: 33.33%;
            display: flex;
            padding-left:40px;
            justify-content: left;
            align-items: flex-start;
            flex-direction: column; 
            align-self: flex-start;
            .list-menu-item{

                width:100%;
                background-color: #f3f3f3!important;
                padding: 14px!important;
                box-shadow: 4px 4px 5px #cfcfcf;
                margin: 0 0 42px;
            }
            .list-menu-item h5{
                 color: #368da7!important;
                 font-size: 18px;
                font-style: normal;
                font-weight: 600;
                text-transform: none;
            }
            .list-menu-item ul{
                list-style: none;
                padding: 0;
                background: 0 0;
                border: 0;
                margin: 0;
                padding: 0;
                vertical-align: baseline;
                outline: 0;
                color: #3b3b3b;
            }
            .list-menu-item li{
                line-height: 27px;
                letter-spacing: .07em!important;
                font-size: 14px;
                padding: 5px 0;
                margin: 0;
                vertical-align: baseline;
            }
            .list-menu-item a{
                
                text-decoration: none;
                color:  #303030 !important;
                font-weight: 400;
            }
            .list-menu-item a:hover{
                color: #9bd9dd !important;
                font-weight: 400;
            }
        }
    }

           
}
</style>


// WEBPACK FOOTER //
// src/view/gensuniversedetail/gensone.vue